module.exports = __webpack_public_path__ + "img/finglawoffbanner.f5a21157.png";